import * as React from 'react';
import {DropdownItem, DropdownMenu, DropdownToggle, Table, UncontrolledDropdown} from 'reactstrap';
import SettingsIcon from 'mdi-react/SettingsIcon';
import Paginacion from '../../../common/paginacion/paginacion';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import GeoModal from './geo-modal';
import ConfirmationModal from '../../../common/modal/confirmation-modal';
import {lazyInject, TYPES} from '../../../../utils/inversify-config';
import MiranaServiceClient from '../../../../middleware/mirana-client';
import {error, success} from '../../../../utils/notification-actions';
import VisicoolerEstadoModal from './visicooler-estado-modal';
import MiranaState from '../../../../reduxstore/mirana-state';
import {Store} from 'react-redux';
import {IFuerzaVenta} from '../../../../utils/constants';

interface VisicoolersTableProps {
    keyword: string;
    data?: mirana.BuscarVisicoolersResponse;
    fuerzaVenta?: IFuerzaVenta;
    handlePagination: (page: number) => void;
    actualizarData: (data: mirana.BuscarVisicoolersResponse) => void;
}

interface VisicoolersTableState {
    openGeoModal: boolean;
    openConfirmationModal: boolean;
    openEditarModal: boolean;
    selectedVisicooler?: mirana.IUIVisicooler;
}

class VisicoolersTable extends React.Component<VisicoolersTableProps, VisicoolersTableState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    @lazyInject(TYPES.REDUX_STORE)
    public reduxStore: Store<MiranaState>;

    constructor(props) {
        super(props);
        this.state = {
            openGeoModal: false,
            openConfirmationModal: false,
            openEditarModal: false
        };
        this.handleGeoClick = this.handleGeoClick.bind(this);
        this.openConfirmationModal = this.openConfirmationModal.bind(this);
        this.handleRetirar = this.handleRetirar.bind(this);
        this.submitEditarForm = this.submitEditarForm.bind(this);
    }

    private handleGeoClick(visicooler: mirana.IUIVisicooler) {
        this.setState({selectedVisicooler: visicooler});
        this.toggleGeoModal();
    };

    private async handleRetirar() {
        try {
            if (!this.state.selectedVisicooler) {
                this.reduxStore.dispatch(error('Error', 'No se seleccionó ningún visicooler'));
            } else {
                const {clienteId, modeloId} = this.state.selectedVisicooler;
                if (!clienteId || !modeloId || !this.props.fuerzaVenta) {
                    this.reduxStore.dispatch(error('Error', 'No se reconoce código de cliente o código de visicooler'));
                } else {
                    await this.apiClient.retirarVisicooler(clienteId, this.props.fuerzaVenta.id, modeloId);
                    this.reduxStore.dispatch(success('Notificación', 'Se retiro el visicooler correctamente'));
                    const newData = {...this.props.data} as any;
                    const index = newData.visicoolers.findIndex(el => el.clienteId === clienteId && el.modeloId === modeloId);
                    newData.visicoolers.splice(index, 1);
                    this.props.actualizarData(newData);
                    this.setState({
                        openConfirmationModal: false
                    });
                }
            }
        } catch (ex) {
            this.reduxStore.dispatch(error('Error', 'Error al retirar visicooler'));
        }
    };

    private openConfirmationModal(visicooler: mirana.IUIVisicooler) {
        this.setState({
            selectedVisicooler: visicooler,
        });
        this.toggleConfirmationModal();
    };

    private openEditarModel(visicooler: mirana.IUIVisicooler) {
        this.setState({
            selectedVisicooler: visicooler,
        });
        this.toggleEditarModal();
    };

    private toggleConfirmationModal = () => {
        this.setState({
            openConfirmationModal: !this.state.openConfirmationModal
        });
    };

    private toggleEditarModal = () => {
        this.setState({
            openEditarModal: !this.state.openEditarModal
        });
    };

    private toggleGeoModal = () => {
        this.setState({
            openGeoModal: !this.state.openGeoModal
        });
    };

    private rangoClassname = (rango: string | null | undefined): string => {
        if (rango === 'ACEPTABLE') {
            return 'text-success';
        } else if (rango === 'REGULAR') {
            return 'text-warning';
        } else if (rango === 'DEFICIENTE') {
            return 'text-orange';
        } else if (rango === 'ALERTA') {
            return 'text-danger';
        }
        return '';
    };

    private async submitEditarForm(values) {
        try {
            if (!this.state.selectedVisicooler) {
                this.reduxStore.dispatch(error('Error', 'No se seleccionó ningún visicooler'));
            } else {
                const {modeloId, clienteId, estado, fuerzaVentaId} = values;
                await this.apiClient.actualizarVisicooler(clienteId, modeloId, fuerzaVentaId, estado ? estado.value : null);
                this.reduxStore.dispatch(success('Notificación', 'Se actualizó el estado del visicooler correctamente'));
                const newData = {...this.props.data} as any;
                const index = newData.visicoolers.findIndex(el => el.clienteId === clienteId && el.modeloId === modeloId);
                newData.visicoolers[index].estado = estado ? estado.label : null;
                this.props.actualizarData(newData);
                this.setState({
                    openEditarModal: false
                });
            }
        } catch (ex) {
            this.reduxStore.dispatch(error('Error', 'Error al actualizar estado de visicooler'));
        }
    };

    private get rows() {
        const content: any[] = [];
        if (this.props.data && this.props.data.visicoolers) {
            this.props.data.visicoolers.forEach((visicooler, idx) => {
                content.push(
                    <tr key={idx}>
                        <td>{visicooler.mesa}</td>
                        <td className={'center-col'}>{visicooler.ruta}</td>
                        <td className={'center-col'}>{visicooler.diaVisita}</td>
                        <td className={'center-col'}>{visicooler.clienteId}</td>
                        <td>{visicooler.clienteRazonSocial}</td>
                        <td>{visicooler.modelo}</td>
                        <td>{visicooler.estado}</td>
                        <td className={'center-col'}>{visicooler.avanceCuota}</td>
                        <td className={'center-col'}>{visicooler.productividad ? visicooler.productividad : 0}%</td>
                        <td className={'center-col'}><p
                            className={`rango ${this.rangoClassname(visicooler.rango)}`}>{visicooler.rango}</p>
                        </td>
                        <td className={'center-col'}>
                            <UncontrolledDropdown>
                                <DropdownToggle className='icon context-button' outline={true}>
                                    <SettingsIcon/>
                                </DropdownToggle>
                                <DropdownMenu className='dropdown__menu'>
                                    <DropdownItem onClick={() => this.handleGeoClick(visicooler)}>Ver
                                        Mapa</DropdownItem>
                                    <DropdownItem onClick={() => this.openEditarModel(visicooler)}>Editar</DropdownItem>
                                    <DropdownItem onClick={() => this.openConfirmationModal(visicooler)}>Retirar
                                        Visicooler</DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </td>
                    </tr>
                )
            });
        }
        return content;
    }

    public render() {
        return (
            <>
                <Table striped={true} className='table--bordered' responsive={true}>
                    <thead>
                    <tr>
                        <th>Mesa</th>
                        <th className={'center-col'}>Ruta</th>
                        <th className={'center-col'}>Visita</th>
                        <th className={'center-col'}>Código</th>
                        <th>Razón Social</th>
                        <th>V. Modelo</th>
                        <th>V. Estado</th>
                        <th className={'center-col'}>Avance</th>
                        <th className={'center-col'}>Productividad</th>
                        <th className={'center-col'}>Rango</th>
                        <th className={'center-col'}/>
                    </tr>
                    </thead>
                    <tbody>
                    {this.rows}
                    </tbody>
                </Table>
                {this.props.data ? <Paginacion numFound={this.props.data.numFound} pageSize={this.props.data.pageSize}
                                               page={this.props.data.page}
                                               handleClick={this.props.handlePagination}/> : null}
                <GeoModal isOpen={this.state.openGeoModal} toggle={this.toggleGeoModal}
                          data={this.state.selectedVisicooler}/>
                <ConfirmationModal title='Confirmación' message='¿Está seguro que desea retirar el visicooler?'
                                   color='primary' colored={false} handleOk={this.handleRetirar}
                                   toggle={this.toggleConfirmationModal}
                                   isOpen={this.state.openConfirmationModal}/>
                <VisicoolerEstadoModal onSubmit={this.submitEditarForm} toggle={this.toggleEditarModal}
                                       visicooler={this.state.selectedVisicooler}
                                       isOpen={this.state.openEditarModal}/>
            </>
        );
    }
}

export default VisicoolersTable;


// WEBPACK FOOTER //
// ./src/components/pages/visicooler/clientes/visicooler-cliente-table.tsx